import { C1Button, C1ButtonProps } from 'c1ui'
import React, { useState, FC } from 'react'

export type C1CoolDownButtonProps = C1ButtonProps & {
    coolDown?: number,
}

export const C1CoolDownButton: FC<C1CoolDownButtonProps> = ({ coolDown, disabled, onClick, ...props }) => {
    const [coolingDown, setCoolingDown] = useState(false)
    const _onClick: React.MouseEventHandler<HTMLButtonElement> = (...args): void => {
        if (coolDown) {
            setCoolingDown(true)
            setTimeout(() => setCoolingDown(false), coolDown)
        }
        if (onClick) {
            return onClick(...args)
        }
    }

    return (
        <C1Button onClick={_onClick} {...props} disabled={coolingDown || disabled}>
            {props.children}
        </C1Button>
    )
}
